







































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component({})
export default class CoreTextInput extends Vue {
    @Prop({ default: '' }) public placeholder!: string;
    @Prop({ default: [] }) public labels!: Array<string>;
    @Prop({ default: false }) public invalid!: boolean;
    @Prop({ default: false }) public disabled!: boolean;
    @Prop() public value!: string;
    @Prop({ default: false }) public fsMask!: boolean;
    @Prop({ default: 'text' }) type!: string;

    public active = false;

    public focus() {
        this.active = true;
    }

    public get withPrefix() {
        return !!this.$slots.prefix;
    }

    public get withSuffix() {
        return !!this.$slots.suffix;
    }

    public get inputInnerClasses() {
        return {
            'not-empty': this.value !== '',
            active: this.active,
            disabled: this.disabled,
            invalid: this.invalid,
        };
    }

    @Emit('input')
    public input(e: any): string {
        this.change();
        return e.target.value;
    }

    @Emit('change')
    public change(): string {
        return this.value;
    }

    @Emit('blur')
    public blur() {
        this.active = false;
    }
}
